var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 19.8825L12.6758 3.00939M12.6758 19.8825L13.7759 20.2954C16.2794 21.2349 19.0722 21.2349 21.5756 20.2954C22.2401 20.0461 22.6758 19.4423 22.6758 18.7709V4.92026C22.6758 3.99836 21.6833 3.36798 20.7709 3.71036C18.784 4.45598 16.5675 4.45598 14.5806 3.71036L12.6895 3.00068C12.6829 2.99822 12.6758 3.00275 12.6758 3.00939M12.6758 19.8825L11.5756 20.2954C9.07216 21.2349 6.2794 21.2349 3.77592 20.2954C3.11147 20.0461 2.67578 19.4423 2.67578 18.7709L2.67578 4.92026C2.67578 3.99836 3.66825 3.36798 4.58063 3.71036C6.56754 4.45598 8.78403 4.45598 10.7709 3.71036L12.6621 3.00068C12.6686 2.99822 12.6758 3.00275 12.6758 3.00939",
    stroke: "#0D4740",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.2ce5934607e612041dc16e324d9f65dd.svg";
export { ForwardRef as ReactComponent };